import { ROUTE_PATH } from "common/constants/sm-constants";
import {
  GridMetaModel,
  Headers,
} from "common/models/utility-models/meta-model";

export class EmailLogsGridMetaModel extends GridMetaModel<Headers> {
  constructor() {
    super(
      "Email Logs",
      ROUTE_PATH.emailLogsList,
      ROUTE_PATH.addMentor,
      false,
      false,
      8,
      false,
      false,
      ["orgname"],
      true,
      [],
      {
        isDownloadExcel: true,
        excelFileName: "email-logs.xlsx",
        btnLabel: "Download Logs",
        headers: [
          { key: "StudentName", value: "student_name" },
          { key: "StudentEmail", value: "student_email" },
          { key: "StudentMobile", value: "student_mobile" },
        ],
      },
      false,
      null,
      false,
      false,
      false,
      null,
      { evalKey: "wantToDelete", evalParam: [1], decisiveParam: true },
      false,
      null,
      {
        isPreview: false,
        isPreviewType: "VIDEO",
        isEnvUrl: false,
        linkKey: ["filePath"],
        previewName: "",
      },
      {
        isTabSwitch: false,
        label: "",
        isChecked: false,
      },
      false
    );
  }

  prepareHeaderList(): Headers[] {
    const headers: Headers[] = [];
    const StudentName = new Headers(
      "Student Name",
      "student_name",
      false,
      true,
      "text"
    );
    const StudentEmail = new Headers(
      "Student Email",
      "student_email",
      false,
      true,
      "text"
    );
    const StudentMobile = new Headers(
      "Student Mobile",
      "student_mobile",
      false,
      true,
      "text"
    );
    const view = new Headers('View', 'view', false, false, 'view')
    // const createdAt = new Headers('Updated Date', 'createdAt', false, true, 'text');
    headers.push(StudentName);
    headers.push(StudentEmail);
    headers.push(StudentMobile);
    headers.push(view);
    //studentCount

    return headers;
  }
}
